import React from 'react';
import Icon from '../shared/Icon';
import './CsvReviewModal.css';
import CsvReviewUnified from './CsvReviewUnified';

/**
 * Modal wrapper for CSV HITL review
 */
const CsvReviewModal = ({
  phase,
  reviewPayload,
  definitionSource,
  suggestionsFailed,
  editedDefinitions,
  invalidColumns,
  error,
  onSubmitReview,
  onUpdateDefinition,
  onUpdateDefinitionField,
  onClose,
}) => {
  const handleSubmit = async () => {
    await onSubmitReview();
  };

  // Primary "no empty descriptions" gate: every rendered column must have a
  // non-empty description before submit is allowed (PRD-893 one-shot approval).
  const hasColumns =
    editedDefinitions.length > 0 &&
    editedDefinitions.some(def => def.fields.length > 0);
  const allDescriptionsFilled =
    hasColumns &&
    editedDefinitions.every(def =>
      def.fields.every(f => f.description && f.description.trim())
    );

  const renderContent = () => {
    if (phase === 'loading') {
      return (
        <div className="csv-review-loading">
          <Icon name="hourglass_top" className="csv-review-loading-icon" size={40} />
          <p className="csv-review-loading-text">Loading review data...</p>
        </div>
      );
    }

    if (phase === 'failed') {
      return (
        <div className="csv-review-error">
          <Icon name="error_outline" className="csv-review-error-icon" size={40} />
          <p className="csv-review-error-text">{error || 'Failed to load review data'}</p>
          <button className="csv-review-button csv-review-button-secondary" onClick={onClose}>
            Close
          </button>
        </div>
      );
    }

    if (phase === 'submitting') {
      return (
        <div className="csv-review-loading">
          <Icon name="hourglass_top" className="csv-review-loading-icon" size={40} />
          <p className="csv-review-loading-text">Submitting review...</p>
        </div>
      );
    }

    return (
      <CsvReviewUnified
        definitions={editedDefinitions}
        definitionSource={definitionSource}
        suggestionsFailed={suggestionsFailed}
        invalidColumns={invalidColumns || []}
        csvSummaries={reviewPayload?.csv_summaries || []}
        onUpdateDefinition={onUpdateDefinition}
        onUpdateDefinitionField={onUpdateDefinitionField}
      />
    );
  };

  const isReviewing = phase === 'reviewing';

  return (
    <>
      <div className="csv-review-backdrop" onClick={onClose} />
      <div className="csv-review-modal">
        <div className="csv-review-header">
          <h2 className="csv-review-title">Review Data Definitions</h2>
          <button className="csv-review-close" onClick={onClose}>
            <Icon name="close" />
          </button>
        </div>

        {error && phase === 'reviewing' && (
          <div className="csv-review-error-banner">
            <Icon name="warning" />
            <span>{error}</span>
          </div>
        )}

        <div className="csv-review-body">
          {renderContent()}
        </div>

        {isReviewing && (
          <div className="csv-review-footer">
            <button className="csv-review-button csv-review-button-secondary" onClick={onClose}>
              Cancel
            </button>
            <button
              className="csv-review-button csv-review-button-primary"
              onClick={handleSubmit}
              disabled={!allDescriptionsFilled}
              title={allDescriptionsFilled ? undefined : 'Enter a description for every column to continue'}
            >
              Approve & Continue
            </button>
          </div>
        )}
      </div>
    </>
  );
};

export default CsvReviewModal;
